// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MsgDecoder } from './Factory/MsgDecoder';
import { DataBuffer } from './DataBuffer';
import { SocketDataStream } from './BufferedProcessor/SocketDataStream';
import { FieldsFactory } from './Factory/FieldsFactory';
import { PFixFieldSet } from './Fields/FieldsImport';
import * as vendorMessage from './Messages/MessagesImport';
import * as vendorGroup from './Groups/GroupsImport';
import * as directMessage from '@shared/utils/DirectMessages/DirectMessagesImport';
import { Message } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { FINISH_BLOCK_TRANSFER } from '@shared/utils/CommonConst';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { DirectPropertyOwner, InformationMessageType, SlTpPriceType, SubscribeType, SubscriptionSource } from '@shared/utils/Enums/Constants';
import { CustomErrorClass, ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { NO_BIND_TO } from '@shared/utils/Trading/OrderConstants';
import { StrategySubscriptionStatus } from '@shared/utils/TradingIdeas/StrategySubscriptionStatus';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { SLTPTrigger } from '@shared/utils/SlTpTrigger';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { OrderEditRequestData } from '@shared/utils/Trading/OrderEditRequestData';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { PriceLimitValidation } from '@shared/utils/Instruments/PriceLimitValidation';
import { ClientType } from '@shared/utils/ClientType';
import { UUID } from '@shared/utils/UUID';
import { ClusterNodeGroupContainer } from './GroupUtils/ClusterNodeGroupContainer';
import { OrderStatus } from '@shared/utils/Trading/OrderStatus';
import { MathUtils } from '@shared/utils/MathUtils';
import { ProXOREncryptionUtility, EncodeKeyAesGcmNoPadding, EncrTypes } from '@shared/utils/EncryptionUtils';
import { OrderLinkType } from '@shared/utils/Trading/OrderLinkTypeEnum';
import { ServerMessaeContainer } from '@shared/utils/FullLogs/ServerMessageContainer';
import { ServerMessaeSide } from '@shared/utils/FullLogs/ServerMessageSide';
import { VerificationMode } from '@shared/commons/UtilsClasses/VerificationMode';
import { ChangePasswordStatusEnum } from '@shared/utils/Enums/ChangePasswordStatusEnum';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
import { CommissionOperationType } from '@shared/utils/Commission/CommissionEnums';
export class ProcessorWorker {
    constructor(mode) {
        this.dataStream = null;
        this.isSSL = false;
        this.siteAddres = '';
        this.StreamKey = null;
        this.InstrumentsSubscribeFaltureTable = {};
        this.FMsgDecoder = new MsgDecoder(this);
        this.OnNewMessageDelegate = null;
        this.OnDisconnect = null;
        this.SessionId = '<Empty>';
        this.OnConnectionLost = null;
        this.OnError = null;
        // TODO. Implement or remove?
        this.parent = null;
        this.symbolSubscriptionDict = {};
        this.finished = false;
        this.nonFixedList = false;
        this.StreamModeStringName = '';
        this.FullLogHandler = null;
        this.WrappersHandlers = {};
        this.WrappersHandlersTrading = {};
        // public RouteQuoteId_VS_RouteId : any = {};
        this.RoutesSupported = {};
        this.Address = '';
        this.QuoteAddresses = [];
        this.serverMaxFieldNumber = Number.MAX_VALUE;
        this.DelayedMessages = [];
        this.sendMessageAsync = (message, isHandleBusinessRejectMessage) => __awaiter(this, void 0, void 0, function* () {
            const result = yield new Promise((resolve) => {
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
            if (!isValidArray(result)) {
                return null;
            }
            const responseMessage = result[0];
            if (isNullOrUndefined(responseMessage)) {
                return null;
            }
            if (isHandleBusinessRejectMessage && responseMessage.Code === Message.CODE_BUSINESS_REJECT_MESSAGE) {
                this.Notify(responseMessage);
                return null;
            }
            else {
                return responseMessage;
            }
        });
        this.StreamMode = mode; // || ProcessorWorker.MODE_QUOTESTREAM;
        this.InstrumentsSubscribeFaltureTable.Count = 0;
        this.CreateStringStreamModeName();
    }
    // #region stream main work
    SendMessage(pfixmsg) {
        const buffer = new DataBuffer();
        const fieldSet = pfixmsg.FieldSet;
        const code = pfixmsg.Code;
        fieldSet.Write(buffer, this.serverMaxFieldNumber);
        const length = buffer.Length();
        const dv = new DataView(new ArrayBuffer(length + 4));
        // size
        dv.setInt32(0, length);
        // data
        const bytes = buffer.ReadAllBytes();
        for (let i = 0; i < length; i++) {
            dv.setInt8(i + 4, bytes[i]);
        }
        this.dataStream.SendData(dv.buffer, code);
        if (this.FullLogHandler) {
            // 4th arg for outgoing message
            this.FullLogs(fieldSet, true, length, true);
        }
    }
    // Moved to worker
    AppendData(data) {
        const dv = new DataView(data);
        let currIndex = 0;
        while (currIndex < data.byteLength) {
            // длина мессаджа - 4 байта
            if (data.byteLength - currIndex < 4) {
                return;
            }
            const length = dv.getInt32(currIndex);
            currIndex += 4;
            // Копируем из массива данных бинарное сообщение и отправляем его
            const msg = this.CopyData(dv, currIndex, length);
            if (msg != null) {
                currIndex += length;
                this.Push(msg);
            }
            else {
                // в буфере не осталось достаточно символов - выходим
                currIndex -= 4;
                break;
            }
        }
    }
    // Moved to worker
    CopyData(dv, curIndex, count) {
        if (curIndex + count <= dv.byteLength) {
            const newData = [];
            for (let i = 0; i < count; i++) {
                newData[i] = dv.getInt8(curIndex++);
            }
            return newData;
        }
        else {
            return null;
        }
    }
    // Moved to worker
    GetFieldSet(msg) {
        const fieldSet = new PFixFieldSet();
        const buffer = new DataBuffer(msg);
        fieldSet.Read(buffer);
        return fieldSet;
    }
    Push(bytes) {
        const fs = this.GetFieldSet(bytes);
        if (this.FullLogHandler) {
            this.FullLogs(fs, false, bytes.length);
        }
        const messages = this.FMsgDecoder.Decode(fs);
        const rqi = fs.GetField(FieldsFactory.FIELD_REQUEST_ID);
        if (rqi) {
            if (this.CheckIsHandled(rqi.Value, messages)) {
                return;
            }
        }
        if (Array.isArray(messages)) {
            for (let i = 0; i < messages.length; i++) {
                if (messages[i]) {
                    if (!messages[i].IsDirect) {
                        const rqi = messages[i].FieldSet.GetField(FieldsFactory.FIELD_REQUEST_ID);
                        if (rqi) {
                            if (this.CheckIsHandled(rqi.Value, messages[i])) {
                                continue;
                            }
                        }
                    }
                    else if (messages[i].OrderNumber || messages[i].OrderId) {
                        this.CheckIsTraidingHandled(messages[i]);
                    }
                    else if (messages[i].RequestID) {
                        this.CheckIsHandled(messages[i].RequestID, messages[i]);
                    }
                    this.Notify(messages[i]);
                }
            }
        }
    }
    static SendMessageToVendor(url_1, isSSL_1, msgType_1, dataForMsg_1, FullLogHandler_1) {
        return __awaiter(this, arguments, void 0, function* (url, isSSL, msgType, dataForMsg, FullLogHandler, mode = ProcessorWorker.MODE_TRADESTREAM) {
            if (!ProcessorWorker.prototype[msgType]) {
                return yield Promise.resolve(null);
            }
            const stream = new ProcessorWorker(mode);
            if (FullLogHandler) {
                stream.FullLogHandler = FullLogHandler;
            }
            stream.siteAddres = url;
            stream.isSSL = isSSL;
            return yield new Promise((resolve, _reject) => {
                stream.OnError = () => {
                    resolve(null);
                };
                stream
                    .OpenWS()
                    .then((opened) => {
                    if (!opened) {
                        resolve(null);
                        return;
                    }
                    stream[msgType](dataForMsg)
                        .then((result) => {
                        stream.Disconnect();
                        resolve(result);
                    })
                        .catch((error) => {
                        console.error('Error in msgType call:', error);
                        resolve(null);
                    });
                })
                    .catch((error) => {
                    console.error('Error opening WebSocket:', error);
                    resolve(null);
                });
            });
        });
    }
    CheckIsTraidingHandled(msg) {
        let rqi = msg.OrderNumber || msg.OrderId;
        let handler = this.WrappersHandlersTrading[rqi];
        if (!handler) {
            rqi = msg.ClientOrderId;
            handler = this.WrappersHandlersTrading[rqi];
        }
        if (!handler) {
            return false;
        }
        if (msg.OrderStatus === OrderStatus.PENDING_NEW || msg.Status === OrderStatus.PENDING_NEW) {
            return false;
        }
        handler(msg);
        delete this.WrappersHandlersTrading[rqi];
        return true;
    }
    CheckIsHandled(rqi, msg) {
        const handler = this.WrappersHandlers[rqi];
        if (!handler) {
            return false;
        }
        handler(msg);
        delete this.WrappersHandlers[rqi];
        return true;
    }
    // #endregion
    // #region  connect disconnect
    ConnectToServer(serverAdress, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!serverAdress) {
                return yield Promise.reject(this.CreateOpenWSError('No Server Adress', 14, 1003));
            }
            return yield this.ConnectionInProcess(serverAdress, params);
        });
    }
    ConnectionInProcess(serverAdress, params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isSSL = params.isSSL;
            this.siteAddres = serverAdress;
            this.reconnect = params.reconnect;
            return yield this.OpenWS()
                .then((opened) => __awaiter(this, void 0, void 0, function* () {
                if (opened) {
                    return yield this.Connect(params);
                }
                else {
                    return yield Promise.reject(this.CreateOpenWSError("Can't open stream", 13, 100));
                }
            }))
                .catch((connerr) => __awaiter(this, void 0, void 0, function* () {
                /* JSON.stringify(connerr) == `{"Text":"Can't open stream","LogoutType":13,"ErrorCode":100,"Connected":false,"ErrorInConnection":true}` */
                return yield Promise.reject(this.CreateOpenWSError(connerr.message, connerr.code, 1001));
            }))
                .then((connectResult) => __awaiter(this, void 0, void 0, function* () {
                return yield Promise.resolve(connectResult);
            }));
        });
    }
    CreateOpenWSError(errorText, logoutType, errorCode) {
        const result = {};
        result.Text = errorText;
        result.LogoutType = logoutType;
        result.ErrorCode = errorCode;
        result.Connected = false;
        result.ErrorInConnection = true;
        return result;
    }
    // Moved to worker
    OpenWS(sert) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const addresString = `${this.isSSL ? 'wss://' : 'ws://'}${this.siteAddres}/websocket`;
                this.createWebSocket(addresString, sert)
                    .then((ws) => {
                    ws.binaryType = 'arraybuffer';
                    const delegates = {
                        OnOpenDelegate: this.StreamOpened.bind(this, resolve),
                        OnCloseDelegate: this.StreamClosed.bind(this, resolve),
                        OnErrorDelegate: this.StreamError.bind(this, resolve),
                        OnMessageDelegate: this.AppendData.bind(this)
                    };
                    this.dataStream = new SocketDataStream(ws, delegates);
                })
                    .catch((error) => {
                    console.error('Failed to open WebSocket:', error);
                    reject(error);
                });
            });
        });
    }
    createWebSocket(addresString, sert) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === 'undefined') {
                // Node.js environment
                const { default: WebSocket } = yield import('ws');
                if (sert) {
                    const options = {
                        cert: sert,
                        rejectUnauthorized: false
                    };
                    return new WebSocket(addresString, options);
                }
                else {
                    return new WebSocket(addresString);
                }
            }
            else {
                // Browser environment
                return sert ? new WebSocket(addresString, sert) : new WebSocket(addresString);
            }
        });
    }
    Disconnect(isNoNActivity) {
        if (this.dataStream) {
            if (this.StreamMode !== ProcessorWorker.MODE_AUTHENTICATION_REQUEST &&
                this.StreamMode !== ProcessorWorker.MODE_HISTORYSTREAM) {
                const disconnectMSG = new vendorMessage.LogoutMessage();
                disconnectMSG.setText(isNoNActivity ? 'Disconnect due to inactivity' : 'Disconnect.');
                this.SendMessage(disconnectMSG);
            }
            this.dataStream.Dispose();
        }
    }
    CloseStream() {
        if (this.dataStream) {
            this.dataStream.CloseStream();
        }
    }
    // Moved to worker
    StreamOpened(resolve, isOpen) {
        return resolve(true);
    }
    // Moved to worker
    StreamClosed(resolve) {
        // this.Disconnect();
        if (!this.reconnect) {
            return resolve(false);
        }
    }
    // Moved to worker
    StreamError(resolve, isOpen) {
        if (this.OnConnectionLost && this.finished) {
            this.OnConnectionLost();
        }
        if (this.OnError) {
            // TODO необходимо довести reject в ответ Promise-ов с помощью resolve(false);
            this.OnError(resolve);
        }
    }
    // #endregion
    Connect(connectionsParameters, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const hello = new vendorMessage.HelloMessage();
                hello.setHello('hello');
                ProcessorWorker.AddProtocolVersonAndMaxField(hello);
                this.serverMaxFieldNumber = hello.getMaxFieldNumber();
                const rqi = hello.getSequance();
                hello.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(hello);
            })
                .then((helloAnswer) => __awaiter(this, void 0, void 0, function* () {
                const helloMessage = helloAnswer[0];
                const propertyMessage = new directMessage.DirectPropertyMessage();
                propertyMessage.Name = 'RULE';
                const isAllowMiddleRequest = helloMessage.getMaxFieldNumber() >= FieldsFactory.FIELD_QUOTES_LIMIT_RIGHT ? '1' : '0';
                propertyMessage.Value = RulesSet.IS_ALLOW_MIDDLE_REQUEST_ON_CHART + '=' + isAllowMiddleRequest;
                this.OnNewMessageDelegate(propertyMessage);
                return yield this.SendLogonMessage(connectionsParameters, helloMessage, accessToken);
            }))
                .then((logonAnswer) => {
                return this.LogonAnswerProcess(logonAnswer[0]);
            });
        });
    }
    SendLogonMessage(connectionsParameters, helloAnswer, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const hello = helloAnswer;
                const login = connectionsParameters.login || '';
                const Mode = this.StreamMode;
                const clientType = ClientType.getClientType();
                const additionalPassword = connectionsParameters.verificationPassword || null;
                const useGetInitDataRequest = Mode === ProcessorWorker.MODE_TRADESTREAM;
                const dateOfBuild = connectionsParameters.build_date_day || '16.04.2019';
                const prommises = [];
                const EncrType = hello.EncryptionType();
                const logon = new vendorMessage.LogonMessage();
                logon.setLogin(login);
                if (connectionsParameters.accessToken) {
                    logon.setAccessToken(connectionsParameters.accessToken);
                }
                else {
                    const pass = connectionsParameters.pass || '';
                    let pr = null;
                    if (EncrType !== EncrTypes.AES_GCM_NoPadding) {
                        pr = ProXOREncryptionUtility.Encode(pass, hello.getHello()).then((encrPass) => {
                            logon.setPassword(encrPass);
                            return true;
                        });
                    }
                    else {
                        pr = EncodeKeyAesGcmNoPadding(pass, hello.getHello()).then((encrPass) => {
                            logon.setPassword(encrPass);
                            return true;
                        });
                    }
                    prommises.push(pr);
                }
                if (connectionsParameters.brandingKey) {
                    let pr = null;
                    if (EncrType !== EncrTypes.AES_GCM_NoPadding) {
                        pr = ProXOREncryptionUtility.Encode(connectionsParameters.brandingKey, hello.getHello()).then((encrPass) => {
                            logon.setBrandingKey(encrPass);
                            return true;
                        });
                    }
                    else {
                        pr = EncodeKeyAesGcmNoPadding(connectionsParameters.brandingKey, hello.getHello()).then((encrPass) => {
                            logon.setBrandingKey(encrPass);
                            return true;
                        });
                    }
                    prommises.push(pr);
                }
                if (connectionsParameters.ipURL) {
                    logon.setIP(connectionsParameters.ipURL);
                }
                // new
                logon.setConnectionMode(Mode);
                logon.setClientType(clientType);
                if (additionalPassword) {
                    logon.setVerificationPassword(additionalPassword);
                }
                if (connectionsParameters.ExternalResourse) {
                    logon.setExternalResourse(connectionsParameters.ExternalResourse);
                }
                if (connectionsParameters.TokenID) {
                    logon.setTokenID(connectionsParameters.TokenID);
                }
                logon.setCanISendGetInitDataRequest(useGetInitDataRequest);
                logon.setDateOfBuild(dateOfBuild);
                if (connectionsParameters.customerNo) {
                    logon.SetCustomerNo(connectionsParameters.customerNo);
                }
                logon.SetAppInstallId(UUID.getAppInstallID());
                this.WrappersHandlers.logonResolve = resolve;
                void Promise.all(prommises).then(() => {
                    this.SendMessage(logon);
                });
            });
        });
    }
    HandleLogon(msg) { }
    LogonAnswerProcess(logonAnswer, useGetInitDataRequest) {
        if (logonAnswer.Code === Message.CODE_PFIX_LOGON_MESSAGE) {
            return this.LogonWorking(logonAnswer);
        }
        if (logonAnswer.Code === Message.CODE_PFIX_LOGOUT_MESSAGE) {
            return this.LogoutWorking(logonAnswer, useGetInitDataRequest);
        }
    }
    LogonWorking(logon) {
        const userSessionId = logon.getSessionId();
        const login = logon.getLogin();
        const result = { userSessionId, login };
        this.SessionId = userSessionId;
        const clusterNodeGroups = logon.FieldSet.GetGroups(FieldsFactory.CLUSTER_NODE_GROUP, vendorGroup.ClusterNodeGroup);
        const clusterNodeGroupsContainer = new ClusterNodeGroupContainer(clusterNodeGroups);
        /// /////Start////////
        const mess = new directMessage.DirectPropertyMessage();
        mess.Name = 'startblocktransfer';
        mess.Value = 'true';
        this.OnNewMessageDelegate(mess);
        const tradingUnlockLogic = logon.getTradingUnlockLogic();
        if (tradingUnlockLogic) {
            // #89340 & #94446
            TradingLockUtils.IsUseLockTradingByPassword = tradingUnlockLogic > 0;
        }
        if (tradingUnlockLogic === 2 || tradingUnlockLogic === 3) {
            // use one time password
            const useOnTimepassword = new directMessage.DirectPropertyMessage();
            useOnTimepassword.Name = RulesSet.FUNCTION_USE_ONE_TIME_PASSWORD;
            this.DelayedMessages.push(useOnTimepassword);
        }
        if (this.StreamMode === ProcessorWorker.MODE_TRADESTREAM) {
            this.getInitData(logon);
        }
        // version 1.9
        const accessToken = logon.GetAccessToken();
        const accessTokenLifeTime = logon.GetAccessTokenLifeTime();
        const refreshToken = logon.GetRefreshToken();
        const refreshTokenLifeTime = logon.GetRefreshTokenLifeTime();
        const verificationMode = logon.getVerificationMode();
        result.Connected = !!userSessionId;
        result.CngContainer = clusterNodeGroupsContainer;
        result.ErrorInConnection = false;
        result.isPasswordExpired = logon.isPasswordExpired();
        if (result.isPasswordExpired || verificationMode === VerificationMode.GoogleAuthenticator) {
            result.UserID = logon.getFieldValue(FieldsFactory.FIELD_USER_ID);
        }
        result.needVerificationPassword = logon.getNeedVerificationPassword();
        result.verificationMode = verificationMode;
        result.accessToken = accessToken;
        result.accessTokenLifeTime = accessTokenLifeTime;
        result.refreshToken = refreshToken;
        result.refreshTokenLifeTime = refreshTokenLifeTime;
        return result;
    }
    LogoutWorking(logout, useGetInitDataRequest) {
        const result = {};
        const errorText = logout.getText();
        const logoutType = logout.getLogoutType();
        const errorCode = logout.getErrorCode();
        result.Text = errorText;
        result.LogoutType = logoutType;
        result.ErrorCode = errorCode;
        result.Connected = false;
        result.ErrorInConnection = true;
        return result;
    }
    getInitData(logon) {
        const nonFixedList = logon.getIsUnfixedList();
        if (isNullOrUndefined(nonFixedList)) {
            /* Server does not support the request => */
            return;
        }
        // this.SendExchanges()
        const pMsg = new directMessage.DirectPropertyMessage();
        pMsg.Name = RulesSet.FUNCTION_NON_FIXED_LIST;
        pMsg.Value = nonFixedList ? 'true' : 'false';
        this.nonFixedList = nonFixedList;
        this.Notify(pMsg);
        const request = new vendorMessage.InitDataRequest();
        request.setMaxFieldNumber(FieldsFactory.getInstance().MaxFieldNumber);
        if (nonFixedList) {
            /* This part was previously for 'symbols', but now we don't need it cuz symbols.length always == 0. Is InitDataRequestInstrumentsGroup also deprecated ? */
        }
        this.SendMessage(request);
    }
    Notify(message) {
        const code = message.Code;
        if (message.IsDirect) {
            switch (message.Code) {
                case Message.CODE_ASSET_TYPE_MESSAGE:
                    this.FMsgDecoder.AssetDecodeMap[message.Id] = message.Name;
                    break;
                case Message.CODE_INSTRUMENT: {
                    const insID = message.ForwardBaseInstrumentID;
                    const isOptionInNonFixedList = message.InstrType === InstrumentTypes.OPTIONS &&
                        insID !== null &&
                        insID !== -1 &&
                        this.nonFixedList;
                    const instrumentMsgAlreadyReceived = this.FMsgDecoder.GetSymbolById(insID); // #113128
                    if (isOptionInNonFixedList && !instrumentMsgAlreadyReceived) {
                        void this.getInstrumentById(insID).then((messages) => {
                            for (let i = 0; i < messages.length; i++) {
                                if (messages[i].Code === Message.CODE_INSTRUMENT) {
                                    this.OnNewMessageDelegate(messages[i]);
                                }
                            }
                        });
                        return;
                    }
                    break;
                }
                case Message.CODE_PFIX_PROPERTY_MESSAGE:
                    this.handlePropertyMessage(message);
                    return;
                case Message.CODE_ACCOUNTSTATUS:
                case Message.CODE_TEXT_MESSAGE:
                    message.ClusterNode = this.StreamKey;
                    break;
                case Message.CODE_PFIX_ADD_2FA_RESPONSE:
                case Message.CODE_PFIX_CONFIRM_2FA_RESPONSE: {
                    const handle = Object.values(this.WrappersHandlers)[0].bind(this);
                    if (handle) {
                        handle([message]);
                    }
                    return;
                }
            }
            this.OnNewMessageDelegate(message);
        }
        else {
            switch (code) {
                case Message.CODE_PFIX_HELLO_MESSAGE:
                case Message.CODE_PFIX_LOGON_MESSAGE:
                case Message.CODE_PFIX_LOGOUT_MESSAGE: {
                    const handle = this.WrappersHandlers.logonResolve;
                    if (handle) {
                        handle([message]);
                    }
                    delete this.WrappersHandlers.logonResolve;
                    this.HandleLogon(message);
                    if (Message.CODE_PFIX_LOGOUT_MESSAGE !== message.Code || handle) {
                        break;
                    }
                    const msg = new directMessage.DirectPropertyMessage();
                    msg.Name = 'LOGOUT';
                    msg.Value = {
                        LogoutType: message.getLogoutType(),
                        ErrorCode: message.getErrorCode(),
                        Text: message.getText()
                    };
                    this.OnNewMessageDelegate(msg);
                    break;
                }
                case Message.CODE_PFIX_XML_MESSAGE:
                    this.OnNewMessageDelegate(ProcessorWorker.createDirectReportResponseMessage(message));
                    break;
            }
        }
    }
    // TODO. Refactor.
    handlePropertyMessage(msg) {
        var _a;
        const isFinishBlockTransfer = msg.Name === FINISH_BLOCK_TRANSFER;
        if (isFinishBlockTransfer) {
            this.finished = true;
            if ((_a = this.DelayedMessages) === null || _a === void 0 ? void 0 : _a.length) {
                for (let i = 0; i < this.DelayedMessages.length; i++) {
                    this.OnNewMessageDelegate(this.DelayedMessages[i]);
                }
                this.DelayedMessages.length = 0;
            }
            this.trySendPropertyMessage(ProcessorWorker.createLocalRule(RulesSet.VALUE_THROTLING_PANEL_LIMIT_AGGRESSOR_BALANCE, '1'));
            if (this.useProductType) {
                this.trySendPropertyMessage(ProcessorWorker.createLocalRule(RulesSet.FUNCTION_USE_PRODUCT_TYPE, '1'));
            }
        }
        this.trySendPropertyMessage(msg);
    }
    trySendPropertyMessage(msg) {
        if (!msg) {
            return false;
        }
        const tradeStream = this.StreamMode & ProcessorWorker.MODE_TRADESTREAM;
        const isFinishBlockTransfer = msg.Name === FINISH_BLOCK_TRANSFER;
        if (isFinishBlockTransfer || tradeStream) {
            this.OnNewMessageDelegate(msg);
            return true;
        }
        return false;
    }
    static createLocalRule(name, value) {
        const pm = new directMessage.DirectPropertyMessage();
        pm.OwnerType = DirectPropertyOwner.Local;
        pm.Name = 'RULE';
        pm.Value = name + '=' + value;
        return pm;
    }
    // TODO. PFixMsgProcessor.cs->FindRequestTime()
    FindRequestTime(msg) {
        return 0;
    }
    CreateStringStreamModeName() {
        let mode = '';
        if ((this.StreamMode & ProcessorWorker.MODE_QUOTESTREAM) > 0) {
            mode += 'Quote;';
        }
        if ((this.StreamMode & ProcessorWorker.MODE_TRADESTREAM) > 0) {
            mode += 'Trade;';
        }
        if ((this.StreamMode & ProcessorWorker.MODE_HISTORYSTREAM) > 0) {
            mode += 'History;';
        }
        if ((this.StreamMode & ProcessorWorker.MODE_NEWSTREAM) > 0) {
            mode += 'News;';
        }
        this.StreamModeStringName = mode;
    }
    // #region IQuote
    // TODO. Generate lvl1 from lvl2, unsubscribe from lvl1 if lv2 sub exists.
    // TODO. Are HistoryType constants ok here?
    SubscribeQuote(InstrumentId, route, service, forse, isDataSource) {
        if (isDataSource) {
            return;
        }
        if (!forse && this.subscribed(InstrumentId, route, service)) {
            return;
        }
        const sent = this.trySendSubscriptionMessage(InstrumentId, route, service, SubscribeType.SUBSCRIBE);
        if (!sent)
            return;
        // if (this.subscribed(InstrumentId, route, service))
        //    return;
        // DayBar message subscription #57649
        if (this.subscribed(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR)) {
            return;
        }
        this.trySendSubscriptionMessage(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR, SubscribeType.SUBSCRIBE);
    }
    // TODO. Generate lvl1 from lvl2, unsubscribe from lvl1 if lv2 sub exists.
    UnsubscribeQuote(InstrumentId, route, service, forse, isDataSource) {
        if (isDataSource) {
            return;
        }
        const sent = this.trySendSubscriptionMessage(InstrumentId, route, service, SubscribeType.UNSUBSCRIBE);
        if (!sent)
            return;
        // if (!this.subscribed(InstrumentId, route, service))
        //    return;
        // DayBar message unsubscription #57649
        if (!this.subscribed(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR)) {
            return;
        }
        if (this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL1) ||
            this.subscribed(InstrumentId, route, HistoryType.QUOTE_LEVEL2) ||
            this.subscribed(InstrumentId, route, HistoryType.QUOTE_TRADES)) {
            return;
        }
        this.trySendSubscriptionMessage(InstrumentId, route, HistoryType.QUOTE_INSTRUMENT_DAY_BAR, SubscribeType.UNSUBSCRIBE);
    }
    // TODO. Rename.
    trySendSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, isDataSource, targetTrInsID) {
        const group = this.createSubscribeGroup(InstrumentId, route, service, subscriptionActionType, isDataSource, targetTrInsID);
        if (!group)
            return false;
        if (!this.trySetBaseSubscriptionArguments(group, InstrumentId, route, service)) {
            return false;
        }
        group.setGroupID(0);
        group.InstrumentTradableID = InstrumentId;
        group.Route = route;
        group.Service = service;
        if (service === 2) {
            group.setSubscriptionPeriodicity(1);
        }
        const message = new vendorMessage.SubscribeMessage();
        message.setSubscriptionAction(subscriptionActionType);
        message.FieldSet.AddGroup(group);
        void new Promise((resolve, _reject) => {
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            this.WrappersHandlers[rqi] = resolve;
            this.SendMessage(message);
        }).then((message) => {
            const m = message[0] || message;
            if (!m) {
                return;
            }
            m.InstrumentId = InstrumentId;
            m.Route = route;
            // if (!m.ErrorCode)
            this.Notify(m);
            if (m.ErrorCode) {
                this.CheckErrorSubscribeResponse(group);
            }
            else if (group.Service === HistoryType.QUOTE_LEVEL2) {
                this.CheckSuccessSubcribeResponse(group);
            }
        });
        this.updateSymbolSubscriptionDict(InstrumentId, route, service, subscriptionActionType === SubscribeType.SUBSCRIBE);
        return true;
    }
    CheckErrorSubscribeResponse(group) {
        if ((group.Service & HistoryType.QUOTE_LEVEL2) !== HistoryType.QUOTE_LEVEL2) {
            return null;
        }
        const tradableID = group.getTradableInstrumentId();
        const route = group.getRouteId();
        let dict = this.InstrumentsSubscribeFaltureTable[tradableID];
        if (!dict) {
            dict = {};
            this.InstrumentsSubscribeFaltureTable[tradableID] = dict;
            this.InstrumentsSubscribeFaltureTable.Count = Object.keys(this.InstrumentsSubscribeFaltureTable).length - 1;
        }
        dict[route] = HistoryType.QUOTE_LEVEL2;
        const processor = this.FMsgDecoder.FProcTable[Message.CODE_QUOTE];
        if (processor) {
            const q1Dic = processor.Quote1ValidDictionary;
            if (!q1Dic) {
                return null;
            }
            const rDict = q1Dic[route];
            if (!rDict) {
                return null;
            }
            const quote = rDict[tradableID];
            if (!quote) {
                return null;
            }
            quote.TradableId = tradableID;
            quote.QuoteRouteId = route;
            const q2 = directMessage.DirectQuote2Message.GetQute2MessagesFromQuote1ByDenyTable(quote, this.InstrumentsSubscribeFaltureTable);
            if (q2) {
                this.Notify(q2);
            }
        }
        return null;
    }
    CheckSuccessSubcribeResponse(group) {
        const tradableInstrumentId = group.getTradableInstrumentId();
        const SubsrDict = this.InstrumentsSubscribeFaltureTable[tradableInstrumentId];
        if (SubsrDict) {
            const route = group.getRouteId();
            const subscription = SubsrDict[route];
            if (subscription) {
                if (subscription === HistoryType.QUOTE_LEVEL2) {
                    SubsrDict[route] = null;
                    delete SubsrDict[route];
                }
            }
            if (Object.keys(SubsrDict).length === 0) {
                delete this.InstrumentsSubscribeFaltureTable[tradableInstrumentId];
            }
        }
    }
    GetAvancedTable() {
        return this.InstrumentsSubscribeFaltureTable;
    }
    createSubscribeGroup(InstrumentId, route, services, subscriptionActionType, isDataSource, targetTrInsID) {
        // TODO. Option SubscribeGroup.
        // ...
        const group = new vendorGroup.SubscribeGroup();
        if (isDataSource) {
            group.setDataSource(SubscriptionSource.DATASOURCE);
            group.setTargetTradableId(targetTrInsID, SubscriptionSource.DATASOURCE, subscriptionActionType);
        }
        return group;
    }
    SendDataSourceSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, targetTrInsID) {
        const toSubscribe = subscriptionActionType == SubscribeType.SUBSCRIBE;
        if (this.subscribed(InstrumentId, route, service) === toSubscribe) {
            return;
        }
        this.trySendSubscriptionMessage(InstrumentId, route, service, subscriptionActionType, true, targetTrInsID);
    }
    trySetBaseSubscriptionArguments(group, InstrumentId, route, service) {
        const msgDecoder = this.FMsgDecoder;
        group.setTradableInstrumentId(InstrumentId);
        // id требуемого роута
        const routeId = route;
        // id соотв котировочного роута
        const quoteId = msgDecoder.GetRouteQuoteId(routeId);
        // if (routeId !== quoteId)
        //    this.RouteQuoteId_VS_RouteId[quoteId] = route;
        group.setRouteId(quoteId);
        group.setSubscriptionType(service);
        group.setLight(false);
        return true;
    }
    // TODO. Rename.
    updateSymbolSubscriptionDict(InstrumentId, route, service, subscribed) {
        const symSubsDict = this.symbolSubscriptionDict;
        if (!symSubsDict[route]) {
            symSubsDict[route] = {};
        }
        let insItem = symSubsDict[route][InstrumentId];
        if (!insItem) {
            insItem = {};
            symSubsDict[route][InstrumentId] = insItem;
        }
        if (subscribed) {
            insItem[service] = true;
        }
        else {
            delete insItem[service];
        }
    }
    subscribed(InstrumentId, route, service) {
        const symSubsDict = this.symbolSubscriptionDict;
        const serviceSetRoute = symSubsDict[route];
        if (!serviceSetRoute) {
            return false;
        }
        const serviceSetInstrumentId = serviceSetRoute[InstrumentId];
        if (!serviceSetInstrumentId) {
            return false;
        }
        return !!serviceSetInstrumentId[service];
    }
    // #endregion IQuote
    FullLogs(fs, output, msgLength, isOutgoingMessage) {
        const container = new ServerMessaeContainer();
        container.MessageCode = fs.GetField(0).Value;
        container.MessageName = FieldsFactory.GetMsgTypeName(container.MessageCode);
        container.Text = fs.toString();
        container.TextNew = fs.ToStringView();
        container.DataForTreeView = fs.GetData();
        container.Side = output ? ServerMessaeSide.Output : ServerMessaeSide.Input;
        container.Length = msgLength;
        container.Mode = this.StreamMode;
        container.StringMode = this.StreamModeStringName;
        container.IsOutgoingMSG = !!isOutgoingMessage;
        // TODO
        // if (FDialogHolder != null)
        // {
        container.Session = this.SessionId;
        container.NodeAddress = this.siteAddres;
        // }
        this.FullLogHandler(container);
    }
    SubscribeCrossRates() {
        const message = new vendorMessage.SubscribeCrossRateMessage();
        message.setSubscriptionAction(SubscribeType.SUBSCRIBE);
        this.SendMessage(message);
    }
    /// /////History Work
    // #region History Work
    ApplySpreadToBaseInterval(historyParams, bidBaseIntervals, askBaseIntervals, instr) {
        if (instr == null) {
            return;
        }
        if (bidBaseIntervals == null && askBaseIntervals == null) {
            return;
        }
        const spreadPlan = historyParams.Plan;
        const period = historyParams.TimeFrameInfo.Periods;
        if (bidBaseIntervals == null || askBaseIntervals == null) {
            // кейс, когда не нужна вторая часть истории для спредирования
            const intervalsToSpread = bidBaseIntervals || askBaseIntervals;
            const historyType = bidBaseIntervals != null ? HistoryType.QUOTE_LEVEL1 : HistoryType.QUOTE_ASK;
            for (let i = 0; i < intervalsToSpread.length; i++) {
                intervalsToSpread[i].ApplySpread(spreadPlan, instr, period, historyType, null);
            }
            return;
        }
        let askIndex = 0;
        if (historyParams.Plan != null) {
            for (let i = 0; i < bidBaseIntervals.length; i++) {
                const bidBi = bidBaseIntervals[i];
                const askBi = askBaseIntervals.length > askIndex ? askBaseIntervals[askIndex] : null;
                if (bidBi != null && askBi != null && bidBi.FLeftTimeTicks === askBi.FLeftTimeTicks) {
                    // hsa: почему мы брали HistoryType из TimeFrameInfo?
                    // ведь в случае запросы истории по аскам мы спредировали данные наоборот - биды как аски, а аски как биды
                    bidBi.ApplySpread(spreadPlan, instr, period, HistoryType.QUOTE_LEVEL1, askBi);
                    askIndex++;
                }
            }
        }
    }
    // TODO. Ugly. Refactor.
    // Details are in XMLMessageProcessor.
    static createDirectReportResponseMessage(pfixXmlMessage) {
        const msg = new directMessage.DirectReportResponseMessage();
        // if (pfixXmlMessage.length && pfixXmlMessage[0].Code === 14) {
        //     return null;
        // }
        msg.xmlString =
            pfixXmlMessage.getFieldValue(FieldsFactory.FIELD_XML_BODY) ||
                vendorGroup.LineGroup.getLongText(pfixXmlMessage.FieldSet);
        return msg;
    }
    static createDirectReportGroupResponseMessage(pfixMessage) {
        if (!pfixMessage) {
            return null;
        }
        pfixMessage = pfixMessage[0] || pfixMessage;
        if (!pfixMessage) {
            return null;
        }
        const msg = pfixMessage.getDirectReportGroupResponse();
        return msg;
    }
    generateReportPromise(reportId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.serverMaxFieldNumber >= FieldsFactory.FIELD_REPORT_ID) {
                return yield this.requestReportPromise(reportId, params).then(ProcessorWorker.createDirectReportGroupResponseMessage);
            }
            else {
                return yield this.requestOldReportPromise(reportId, params) // старая схема
                    .then(ProcessorWorker.createDirectReportResponseMessage);
            }
        });
    }
    requestReportPromise(reportId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const request = new vendorMessage.ReportGroupRequestMessage();
            const reqId = request.getSequance();
            request.setRequestId(reqId);
            if (params.locale) {
                request.setFieldValue(FieldsFactory.FIELD_LANG, params.locale);
            }
            if ((_a = params.reportTypeObj) === null || _a === void 0 ? void 0 : _a.id) {
                request.setReportId(params.reportTypeObj.id);
            }
            request.setIsTechnicalReport(!!params.IsTechnical);
            const pDict = params.mainParamDict;
            for (const key in pDict) {
                const paramGroup = new vendorGroup.KeyValueGroup();
                paramGroup.setKey(key);
                paramGroup.setValue(pDict[key]);
                request.addGroup(paramGroup);
            }
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[reqId] = resolve;
                this.SendMessage(request);
            });
        });
    }
    requestOldReportPromise(reportId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const request = new vendorMessage.ReportRequestMessage();
            const reqId = request.getSequance();
            request.setRequestId(reqId);
            // +++ server should return time always in UTC
            request.setFieldValue(FieldsFactory.FIELD_TYPE, 1);
            // по умолчанию реквестим имя инструмента с алиасами, но в некоторых случаях,
            // нам нужно истинное, серверное имя
            if (params.locale) {
                request.setFieldValue(FieldsFactory.FIELD_LANG, params.locale);
            }
            request.setTemplateName(reportId);
            if ((_a = params.reportTypeObj) === null || _a === void 0 ? void 0 : _a.id) {
                const repTypeGroup = new vendorGroup.KeyValueGroup();
                repTypeGroup.setKey('reporttype');
                repTypeGroup.setValue(params.reportTypeObj.id.toString());
                request.addGroup(repTypeGroup);
            }
            const pDict = params.mainParamDict;
            for (const key in pDict) {
                const paramGroup = new vendorGroup.KeyValueGroup();
                paramGroup.setKey(key);
                paramGroup.setValue(pDict[key]);
                request.addGroup(paramGroup);
            }
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[reqId] = resolve;
                this.SendMessage(request);
            });
        });
    }
    // #endregion History Work
    /// /////////TODO////////////
    // public FillParamsTable  (stream, historyParams, mode, paramsTable)
    // {
    //     if (paramsTable != null)
    //     {
    //         if (string.IsNullOrEmpty(historyParams.AnotherConnectionURL) && FProcessor != null)
    //             FProcessor.CreateHistoryParams(historyParams, "history", paramsTable);
    //         else if (!string.IsNullOrEmpty(historyParams.AnotherConnectionURL))
    //         {
    //             PFSFXMsgProcessor.CreateHistoryParams(historyParams.AnotherConnectionURL, historyParams.AnotherConnectionURL.StartsWith("https:"), historyParams.AnotherConnectionInstrumentID, historyParams, "history", paramsTable);
    //             paramsTable["l"] = historyParams.AnotherConnectionLogin;
    //             paramsTable["md5p"] = EncryptPassword(historyParams.AnotherConnectionPassword, historyParams.CryptType);
    //         }
    //         if (paramsTable.ContainsKey("r")) //#48726 - мы должны получить ссылку на котировочный роут, иначе данные не загрузятся
    //         {
    //             let processor = stream;
    //             if (processor != null)
    //                 paramsTable["r"] = processor.GetQuoteRouteName(paramsTable["r"]);
    //         }
    //         paramsTable["workMode"] = mode;
    //     }
    // }
    static GetUnifiedAddress(address, secure = null) {
        let defaultPort = '80';
        // отрезаем приставки, мешающие правильному разбору
        let hostName = address.trim();
        if (hostName.startsWith('http://')) {
            hostName = hostName.slice(0, 7);
        }
        // +++ http://tp3.pfsoft.lan/entity/23449
        if (secure !== null) {
            if (secure) {
                if (hostName.startsWith('https://')) {
                    hostName = hostName.slice(0, 8);
                }
                defaultPort = '443';
            }
        }
        else if (hostName.startsWith('https://')) {
            hostName = hostName.slice(0, 8);
            defaultPort = '443';
        }
        if (hostName.startsWith('www.')) {
            hostName = hostName.slice(0, 4);
        }
        const index = hostName.indexOf('/');
        if (index > 0) {
            hostName = hostName.slice(index);
        }
        // определяем порт
        const parts = hostName.split(':');
        const hostNameOrIP = parts[0];
        const port = parts.length > 1 ? parts[1] : defaultPort;
        // TODO кажется ненужно, перформанс немного подъедает
        // let regex = new RegExp("^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$");
        // if (!regex.test(hostNameOrIP))
        // {
        //    try
        //    {
        //        console.log("Host Name Or IP");
        //        ////преобразуем символьное имя в IP
        //        //let entry = Dns.Resolve(hostNameOrIP);
        //        //if (entry.AddressList.length > 0)
        //        //    hostNameOrIP = entry.AddressList[0].ToString();
        //    }
        //    catch (ex)
        //    {
        //        //Utils.log(ex);
        //    }
        // }
        return hostNameOrIP + ':' + port;
    }
    AccountOperationRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.AccountOperationRequestMessage();
                message.setAccountId(data.accountId);
                message.setCounterId(data.counterId);
                message.setAmount(data.amount);
                message.setComment(data.comment);
                message.setOperationType(data.operationType, this.serverMaxFieldNumber);
                if (data.assetId) {
                    message.assetId(data.assetId);
                }
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => msg);
        });
    }
    // #region NFL - NonFixedList
    GetInstrumentList(patern, exchangeIDs, instrumentTypes, aliasLanguage, isOldLookupType) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedInstumentListRequest(null, this.serverMaxFieldNumber, aliasLanguage);
                message.setFilterName(patern);
                message.setExchangeIDs(exchangeIDs);
                message.setInstrumentTypes(instrumentTypes);
                message.setSymbolLookupType(isOldLookupType); // пока сервер не обновился нельзя добавлять данное поле иначе ломается запрос
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    GetOptionsList(patern, exchangeIDs, instrumentTypes, aliasLanguage) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedInstumentListUnderlierRequest(null, this.serverMaxFieldNumber, aliasLanguage);
                message.setFilterName(patern);
                message.setExchangeIDs(exchangeIDs);
                message.setInstrumentTypes(instrumentTypes);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    GetYieldRate(instrumentID, routeID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.YTMRequestMessage();
                message.setInstrumentId(instrumentID);
                message.setRouteId(routeID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    SendExerciseRequest(positionID, status) {
        const message = new vendorMessage.ExerciseRequestMessage();
        message.setPositionID(positionID);
        message.setStatus(status);
        this.SendMessage(message);
    }
    SendInactivityPeriodState(msgText) {
        const message = new vendorMessage.InformationMessage();
        message.setMsgType('info');
        message.setContent([JSON.stringify({ info: msgText })]);
        message.setTimeSpan(new Date());
        this.SendMessage(message);
    }
    SendLogsWhenSettingsWasChanged(propsForLog) {
        const message = new vendorMessage.InformationMessage();
        message.setMsgTypeId(InformationMessageType.Settings);
        message.setContent([JSON.stringify(propsForLog)]);
        message.setTimeSpan(new Date()); // #111674
        this.SendMessage(message);
    }
    SendMarginRequest(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.MarginRequestMessage();
                for (let i = 0; i < parameters.length; i++) {
                    const parameter = parameters[i];
                    const group = new vendorGroup.MarginPFixGroup();
                    group.setAccountId(parameter.accountId);
                    group.setTradableInstrumentID(parameter.instrumentID);
                    group.setRouteId(parameter.routeID);
                    if (parameter.isCashMode) {
                        // #122525
                        group.setCashOrderQty(parameter.cash);
                    }
                    else {
                        group.setAmount(parameter.amount);
                    }
                    if (isValidNumber(parameter.price)) {
                        group.setPrice(parameter.price);
                    }
                    if (isValidNumber(parameter.stopPrice)) {
                        group.setStopPrice(parameter.stopPrice);
                    }
                    // #104724 risks&fees инфо может приходить и без orderType
                    if (!isNullOrUndefined(parameter.orderType)) {
                        group.setOrderType(parameter.orderType);
                    }
                    if (!isNullOrUndefined(parameter.validity)) {
                        group.setValidity(parameter.validity);
                    }
                    const operationMode = parameter.operation === OperationType.Buy
                        ? CommissionOperationType.BUY
                        : CommissionOperationType.SHORT;
                    group.setOperationMode(operationMode);
                    group.setMarginMode(parameter.mode);
                    group.setProductType(parameter.productType);
                    if (!isNullOrUndefined(parameter.leverage)) {
                        group.setLeverage(parameter.leverage);
                    }
                    if (!isNullOrUndefined(parameter.isAllowOTHTrading)) {
                        group.isAllowOTHTrading = parameter.isAllowOTHTrading;
                    }
                    message.addGroup(group);
                }
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    SendAccountFollowerRequest(args) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.AccountFollowerRequestMessage();
                message.setFollowerRequestStatus(args.Status);
                message.setMasterId(args.MasterId);
                if (args.FollowerIDs) {
                    message.setFollowerIds(args.FollowerIDs);
                }
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                const message = msg.length ? msg[0] : msg;
                if (message === null || message === void 0 ? void 0 : message.reject) {
                    return [];
                }
                else {
                    return message;
                }
            });
        });
    }
    SendGoogleAuthRequest(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.GoogleAuthRequestMessage();
                ProcessorWorker.AddProtocolVersonAndMaxField(message);
                message.setUserId(userID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                const message = msg.length ? msg[0] : msg;
                if (message === null || message === void 0 ? void 0 : message.reject) {
                    return [];
                }
                else {
                    return message;
                }
            });
        });
    }
    SendGoogleAuthConfirmRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.GoogleAuthConfirmRequestMessage();
                const { userID, verificationPassword } = data;
                message.setUserId(userID);
                message.setVerificationPassword(verificationPassword);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                const message = msg.length ? msg[0] : msg;
                if (message === null || message === void 0 ? void 0 : message.reject) {
                    return [];
                }
                else {
                    return message;
                }
            });
        });
    }
    SendPortfolioStatisticsRequest(accountId, type, startTime, endTime, routeId, instrumentTradableID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.PortfolioStatisticsRequest();
                message.setAccountId(accountId);
                message.setType(type);
                message.setStartTime(startTime);
                message.setEndTime(endTime);
                message.setRouteId(routeId);
                message.setInstrumentTradableId(instrumentTradableID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    SendNewsSubscribeMessage(routeIDArr, subscribeType) {
        const message = new vendorMessage.NewsSubscribeMessage();
        message.setSubscriptionAction(subscribeType);
        if (routeIDArr) {
            for (let i = 0; i < routeIDArr.length; i++) {
                message.addRouteId(routeIDArr[i]);
            }
        }
        this.SendMessage(message);
    }
    SendNewsRequestMessage(routeID, number, startTime, endTime) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NewsRequestMessage();
                message.setRouteId(routeID);
                message.setNumber(number);
                message.setStartTime(startTime);
                message.setEndTime(endTime);
                message.setSymbol('');
                message.setSource('');
                message.setNewsCategory('');
                message.setPriority(0);
                message.setTheme('');
                message.setIsUpperCaseSearch(true);
                message.setIsContentSearch(false);
                message.setIsEventSearch(false);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                return msg.length ? msg[0] : msg;
            });
        });
    }
    SendCustomListRequest(userID_1, listType_1) {
        return __awaiter(this, arguments, void 0, function* (userID, listType, timeout = 3000) {
            const message = new vendorMessage.CustomListRequestMessage();
            message.setUserId(userID);
            message.setListType(listType);
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            const resArray = [];
            const responsePromise = new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => __awaiter(this, void 0, void 0, function* () {
                return yield this.SendCustomListResponseCollect(msg, rqi, resArray);
            }));
            const timeoutPromise = new Promise((_resolve, reject) => setTimeout(() => {
                reject(new Error('Request timed out'));
            }, timeout));
            return yield Promise.race([responsePromise, timeoutPromise]);
        });
    }
    SendCustomListResponseCollect(msg, rqi, resArray) {
        return __awaiter(this, void 0, void 0, function* () {
            const m = msg[0];
            const reject = m.reject;
            const responseEnd = m.ResponseEnd;
            if (!reject) {
                resArray.push(m);
            }
            if (responseEnd || reject) {
                return resArray;
            }
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
            }).then((newMsg) => __awaiter(this, void 0, void 0, function* () {
                return yield this.SendCustomListResponseCollect(newMsg, rqi, resArray);
            }));
        });
    }
    SendPortfolioModelRequest() {
        const message = new vendorMessage.PortfolioModelRequest();
        this.SendMessage(message);
    }
    AlgorithmSubscribeMessage(subscribe, algorithmId) {
        return __awaiter(this, void 0, void 0, function* () {
            const msg = new vendorMessage.AlgorithmSubscribeMessage();
            msg.setAlgorithmId(algorithmId);
            msg.setSubscribeAction(subscribe);
            const rqi = msg.getSequance();
            msg.setRequestId(rqi);
            yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(msg);
            });
        });
    }
    SendTradingSignalRequest() {
        const message = new vendorMessage.TradingSignalRequestMessage();
        this.SendMessage(message);
    }
    SendTradingSignalSeenRequest(tradingSignalId) {
        const message = new vendorMessage.TradingSignalSeenRequestMessage();
        message.setTradingSignalId(tradingSignalId);
        this.SendMessage(message);
    }
    SendSubscriptionStrategyRequest(tradingSystemId) {
        const message = new vendorMessage.SubscriptionStrategyRequestMessage();
        message.setTradingSystemId(tradingSystemId);
        message.setTradingStrategySubscriptionStatus(StrategySubscriptionStatus.Accepted);
        this.SendMessage(message);
    }
    SendSnapshotRequestMessageAsync(tradableID, routeID) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new vendorMessage.SnapshotRequestMessage();
            message.setInstrumentTradableID(tradableID);
            message.setRouteId(routeID);
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    GetBrandingRules(brandingKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new vendorMessage.BrandingRulesRequestMessage();
            message.setBrandingKey(brandingKey);
            ProcessorWorker.AddProtocolVersonAndMaxField(message);
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            /* eslint-disable compat/compat */
            return yield new Promise((resolve, _reject) => {
                const timeoutMs = 1000 * 60 * 2; // 2 minutes
                const timeout = setTimeout(() => {
                    delete this.WrappersHandlers[rqi];
                    console.error(`BrandingRulesRequestMessage with rqi ${rqi} timed out after ${timeoutMs} ms`);
                    resolve(null);
                }, timeoutMs);
                this.WrappersHandlers[rqi] = (msg) => {
                    clearTimeout(timeout);
                    resolve(msg);
                };
                this.SendMessage(message);
            });
        });
    }
    SendBrokerMessageReport(inputMessage, type) {
        // закоментовано, згодом відновлено  згідно з #110904 (для urgent BM було додано логіювання у #84587, судячи з усього зараз ця логіка вже є застарілою і непотрібною)
        const message = new vendorMessage.BrokerMessage();
        message.setType(type);
        message.setSenderId(inputMessage.TargetID);
        message.setTargetId(inputMessage.SenderID);
        message.setId(inputMessage.ID);
        message.setDate(inputMessage.Date);
        const msgText = '<status refobj="message"' +
            ' refid="' +
            inputMessage.ID +
            '"><field name="reacted" value="true"/></status>';
        message.setText(msgText);
        this.SendMessage(message);
    }
    SendBrokerResponseMessage(brokerMsgID, value, userID, userName, responseType) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new vendorMessage.BrokerResponseMessage();
            message.setId(brokerMsgID);
            message.setValue(value);
            message.setUserID(userID);
            message.setUsername(userName);
            if (responseType !== null) {
                message.setResponseType(responseType);
            }
            ProcessorWorker.AddProtocolVersonAndMaxField(message);
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    SendBrokerMessageHistoryRequest(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = new vendorMessage.BMHistoryRequestMessage();
            message.setUserID(userID);
            ProcessorWorker.AddProtocolVersonAndMaxField(message);
            const rqi = message.getSequance();
            message.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    GetNonFixedInstrumentStrikes(ContractID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedInstumentStrikesRequest();
                message.setContractID(ContractID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    getInstrumentByInstrumentTradableID_NFL(InstrumentTradableID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedNewInstumentRequest();
                message.setInstrumentTradableID(InstrumentTradableID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                if (!msg.length) {
                    return null;
                }
                if (msg[0].Code !== Message.CODE_INSTRUMENT) {
                    return null;
                }
                return msg;
            });
        });
    }
    GetNonFixedInstrumentListByAssetName(AsssetName) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedInstumentListRequest(null, this.serverMaxFieldNumber);
                message.setAssetName(AsssetName);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    getInstrumentById(instrumentID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.NonFixedNewInstumentRequest();
                message.setInstrumentID(instrumentID);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    GetInstrument() { }
    SendPing() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.PingMessage();
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            });
        });
    }
    SendRefreshTokenMsg(token) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.RefreshTokenMesage();
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                message.SetRefreshToken(token);
                ProcessorWorker.AddProtocolVersonAndMaxField(message);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msg) => {
                const msg0 = msg[0];
                if (!msg0) {
                    return null;
                }
                if (msg0.Code === Message.CODE_PFIX_REFRESH_TOKEN) {
                    const TokenDataObj = {};
                    TokenDataObj.Valid = true;
                    TokenDataObj.StreamOpened = true;
                    TokenDataObj.accessToken = msg0.GetAccessToken();
                    TokenDataObj.accessTokenLifeTime = msg0.GetAccessTokenLifeTime();
                    TokenDataObj.refreshToken = msg0.GetRefreshToken();
                    TokenDataObj.refreshTokenLifeTime = msg0.GetRefreshTokenLifeTime();
                    return TokenDataObj;
                }
                return { Valid: false, StreamOpened: true };
            });
        });
    }
    ChangePassword(curPwd, newPwd, UserID, verificationPassword, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.ChangePasswordMessage();
                message.setUserId(UserID);
                message.setPassword(curPwd);
                message.setNewPassword(newPwd);
                if (accessToken) {
                    message.setAccessToken(accessToken); /* #92068 */
                }
                ProcessorWorker.AddProtocolVersonAndMaxField(message);
                if (verificationPassword) {
                    message.setVerificationPassword(verificationPassword);
                }
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            })
                .then((message) => {
                if (!message) {
                    return null;
                }
                const mess = message[0];
                if (mess.IsDirect && mess.Data) {
                    return {
                        Data: mess.Data,
                        RejectCode: mess.BusinessRejectCode,
                        status: ChangePasswordStatusEnum.STATUS_DECLINED,
                        errText: mess.Data[0][1]
                    };
                }
                const status = mess.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
                const MinLength = mess.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
                const MaxLength = mess.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH);
                if (status !== null) {
                    return { Status: status, MinLength, MaxLength };
                }
                return null;
            })
                .catch(() => {
                const ex = new CustomErrorClass('ProcessorWorker changePassword error', 'ProcessorWorker.ChangePassword', 'ChangePassword -> Promise');
                ErrorInformationStorage.GetException(ex);
                return null;
            });
        });
    }
    ChangeTradingPassword(curPwd, newPwd) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.ChangeTradingPasswordMessage();
                message.setPassword(curPwd);
                message.setNewPassword(newPwd);
                ProcessorWorker.AddProtocolVersonAndMaxField(message);
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            })
                .then((message) => {
                if (!message) {
                    return null;
                }
                const mess = message[0];
                if (mess.IsDirect && mess.Data) {
                    return {
                        Data: mess.Data,
                        RejectCode: mess.BusinessRejectCode,
                        status: ChangePasswordStatusEnum.STATUS_DECLINED,
                        errText: mess.Data[0][1]
                    };
                }
                const status = mess.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
                const MinLength = mess.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
                const MaxLength = mess.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH);
                if (status !== null) {
                    return { Status: status, MinLength, MaxLength };
                }
                return null;
            })
                .catch(() => {
                const ex = new CustomErrorClass('ProcessorWorker changeTradingPassword error', 'ProcessorWorker.ChangeTradingPassword', 'ChangeTradingPassword -> Promise');
                ErrorInformationStorage.GetException(ex);
                return null;
            });
        });
    }
    SendInformationMessage(data) {
        const message = new vendorMessage.InformationMessage();
        if (typeof data.msgType === 'string') {
            message.setMsgType(data.msgType);
        }
        else {
            message.setMsgTypeId(data.msgType);
        }
        message.setContent([JSON.stringify(data.content)]);
        message.setTimeSpan(data.timestamp);
        this.SendMessage(message);
    }
    // #region Trading
    reversePosition(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.placeOrderGroups(this.createReversePositionGroups(data), data.placedFrom);
        });
    }
    createReversePositionGroups(data) {
        const closeInitOrderGroup = this.createOrderGroup(data, data.placedFrom);
        closeInitOrderGroup.setOpen(false);
        const reversedOrderGroup = this.createOrderGroup(data, data.placedFrom);
        reversedOrderGroup.setOperationType(data.side === OperationType.Buy ? OperationType.Sell : OperationType.Buy);
        reversedOrderGroup.setOrderIdToLink(closeInitOrderGroup.getClientOrderId());
        reversedOrderGroup.setOrderLinkType(OrderLinkType.ORDER_LINK_EXECUTE_AFTER);
        const orderIdGroup = new vendorGroup.OrderIdGroup();
        orderIdGroup.setOrderId(BigInt(data.position.PositionId));
        closeInitOrderGroup.AddGroup(orderIdGroup);
        this.setOrderGroupPrices(data, OrderType.Market, closeInitOrderGroup);
        this.setOrderGroupPrices(data, OrderType.Market, reversedOrderGroup);
        return [closeInitOrderGroup, reversedOrderGroup];
    }
    // TODO. Answer. Promise.
    // Refactor.
    modifyPosition(data) {
        let changed = false;
        const isSltpEditParams = data.parameterDict.sltp;
        const sltpHolder = isSltpEditParams.sltpHolder;
        const position = data.position;
        const positionHasSL = !!position.SLOrder;
        const positionHasTP = !!position.TPOrder;
        const setNewSL = !isNaN(sltpHolder.StopLossPriceValue);
        const setNewTP = !isNaN(sltpHolder.TakeProfitPriceValue);
        const setTrailingStop = sltpHolder.StopLossPriceType === SlTpPriceType.TrOffset;
        // TODO. Ugly. Details are at the top OrderEditBase
        const canEditSLOrTrailingStop = data.canEditSLOrTrailingStop;
        const canEditTP = data.canEditTP;
        const promises = [];
        // Cancel SL.
        if (canEditSLOrTrailingStop && positionHasSL && !setNewSL) {
            this.cancelOrder(position.SLOrder, data.placedFrom);
            changed = changed || true;
        }
        // Cancel TP.
        if (canEditTP && positionHasTP && !setNewTP) {
            this.cancelOrder(position.TPOrder, data.placedFrom);
            changed = changed || true;
        }
        const orderTypes = OrderType;
        const stopLossLimitValue = sltpHolder.StopLossLimitPriceValue;
        const needSetSLL = stopLossLimitValue != null;
        const stopOrderType = needSetSLL ? orderTypes.StopLimit : orderTypes.Stop; // #91413
        // Place SL.
        if (canEditSLOrTrailingStop && setNewSL && !positionHasSL) {
            const orderType = setTrailingStop ? orderTypes.TrailingStop : stopOrderType;
            const slData = this.createDataForPlacingPositionSLTPOrder(true, data, orderType);
            slData.parameterDict[setTrailingStop ? OrderEditBaseUtils.TRAILING_STOP_PARAM : OrderEditBaseUtils.STOP_PRICE_PARAM] = sltpHolder.StopLossPriceValue;
            if (needSetSLL) {
                slData.parameterDict[OrderEditBaseUtils.LIMIT_PRICE_PARAM] = stopLossLimitValue;
            }
            if (sltpHolder.RealTrStopPrice) {
                slData.parameterDict.RealTrStopPrice = sltpHolder.RealTrStopPrice;
            }
            slData.parameterDict[OrderEditBaseUtils.SLTP_TRIGGER] = SLTPTrigger.GetRawValue(sltpHolder.SLTPTriggerShortValue, data.side, true);
            slData.isAllowOTHTrading = isSltpEditParams.isAllowOTHTradingSL;
            this.placeSLTPOrderForPosition(slData, position, data.placedFrom);
            changed = changed || true;
        }
        // Place TP.
        if (canEditTP && setNewTP && !positionHasTP) {
            const tpData = this.createDataForPlacingPositionSLTPOrder(false, data, orderTypes.Limit);
            tpData.parameterDict.limitPrice = sltpHolder.TakeProfitPriceValue;
            tpData.parameterDict[OrderEditBaseUtils.SLTP_TRIGGER] = SLTPTrigger.GetRawValue(sltpHolder.SLTPTriggerShortValue, data.side, false);
            tpData.isAllowOTHTrading = isSltpEditParams.isAllowOTHTradingTP;
            this.placeSLTPOrderForPosition(tpData, position, data.placedFrom);
            changed = changed || true;
        }
        //  Replace SL.
        if (canEditSLOrTrailingStop && setNewSL && positionHasSL && data.isSLchanged) {
            const slData = this.createDataForReplacingPositionSLTPOrder(position.SLOrder);
            slData.orderTypeId = setTrailingStop ? orderTypes.TrailingStop : stopOrderType;
            slData.parameterDict[setTrailingStop ? OrderEditBaseUtils.TRAILING_STOP_PARAM : OrderEditBaseUtils.STOP_PRICE_PARAM] = sltpHolder.StopLossPriceValue;
            if (needSetSLL) {
                slData.parameterDict[OrderEditBaseUtils.LIMIT_PRICE_PARAM] = stopLossLimitValue;
            }
            if (sltpHolder.RealTrStopPrice) {
                slData.parameterDict.RealTrStopPrice = sltpHolder.RealTrStopPrice;
            }
            slData.placedFrom = data.placedFrom;
            promises.push(this.replaceOrder(slData));
        }
        //  Replace TP.
        if (canEditTP && setNewTP && positionHasTP && data.isTPchanged) {
            const tpData = this.createDataForReplacingPositionSLTPOrder(position.TPOrder);
            tpData.orderTypeId = orderTypes.Limit;
            tpData.parameterDict.limitPrice = sltpHolder.TakeProfitPriceValue;
            tpData.placedFrom = data.placedFrom;
            promises.push(this.replaceOrder(tpData));
        }
        if (promises.length > 0) {
            return Promise.all(promises).then((results) => {
                for (const r of results) {
                    if (!r) {
                        return false;
                    }
                }
                return true;
            });
        }
        else {
            return changed || data.UseSkipNoChange;
        }
    }
    // TODO. Refactor. Ugly.
    createDataForPlacingPositionSLTPOrder(isSL, positionModifyData, sltpOrderType) {
        const position = positionModifyData.position;
        const sltpSide = position.BuySell === OperationType.Buy ? OperationType.Sell : OperationType.Buy;
        const data = new OrderEditRequestData();
        data.orderTypeId = sltpOrderType;
        data.instrument = positionModifyData.instrument;
        data.account = positionModifyData.account;
        data.quote = positionModifyData.quote;
        data.side = sltpSide;
        data.productType = positionModifyData.productType;
        data.tif = OrderUtils.getDefaultSLTPValidity(position, sltpOrderType);
        data.isAllowOTHTrading = isSL ? positionModifyData.isAllowOTHTradingSL : positionModifyData.isAllowOTHTradingTP;
        return data;
    }
    // TODO. Refactor. Ugly.
    createDataForReplacingPositionSLTPOrder(order) {
        const data = new OrderEditRequestData();
        data.instrument = order.Instrument;
        data.account = order.Account;
        data.side = order.BuySell;
        data.tif = new TIF(order.TimeInForce, new Date(order.ExpireAt));
        data.isAllowOTHTrading = order.IsAllowOTHTrading;
        data.order = order;
        return data;
    }
    // TODO. Refactor. Ugly.
    placeSLTPOrderForPosition(sltpData, position, placedFrom) {
        const sltpGroup = this.createOrderGroup(sltpData, placedFrom);
        if (!sltpGroup) {
            return;
        }
        sltpGroup.setOpen(false);
        sltpGroup.setBoundTo(-1);
        this.setOrderGroupPrices(sltpData, sltpData.orderTypeId, sltpGroup);
        const boundToPositionGroup = new vendorGroup.OrderIdGroup();
        boundToPositionGroup.setOrderId(position.PositionId);
        sltpGroup.AddGroup(boundToPositionGroup);
        this.placeOrderGroups([sltpGroup], placedFrom);
    }
    // TODO. Answer. Promise.
    placeOrder(data) {
        let orderGroups = null;
        const ordTypes = OrderType;
        const ordType = data.orderTypeId;
        if (ordType === ordTypes.OCO) {
            orderGroups = this.createOCOGroups(data);
        }
        else {
            const orderGroup = this.createOrderGroup(data, data.placedFrom);
            if (!orderGroup) {
                return;
            }
            this.setOrderGroupPrices(data, ordType, orderGroup);
            orderGroups = [orderGroup];
        }
        this.placeOrderGroups(orderGroups, data.placedFrom);
    }
    placeOrderAsync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const orderGroups = this.createPlaceOrderGroups(data);
            if (orderGroups === null) {
                return yield Promise.reject();
            }
            return yield this.placeOrderGroupsAsync(orderGroups, data.placedFrom, false);
        });
    }
    createPlaceOrderGroups(data) {
        let orderGroups = null;
        const ordType = data.orderTypeId;
        if (ordType === OrderType.OCO) {
            orderGroups = this.createOCOGroups(data);
        }
        else {
            const orderGroup = this.createOrderGroup(data, data.placedFrom);
            if (!orderGroup) {
                return null;
            }
            this.setOrderGroupPrices(data, ordType, orderGroup);
            orderGroups = [orderGroup];
        }
        return orderGroups;
    }
    multiplyPlaceOrdersAsync(multiplyOrders, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const orderGroups = [];
            const requestData = multiplyOrders;
            for (const data of requestData) {
                const og = this.createPlaceOrderGroups(data.orderEditBase.getDataForRequest());
                if (og === null) {
                    continue;
                }
                orderGroups.push(...og);
            }
            return yield this.placeOrderGroupsAsync(orderGroups, placedFrom, true);
        });
    }
    // TODO. Answer. Promise.
    placeOrderGroups(orderGroups, placedFrom) {
        const orderMessage = new vendorMessage.NewOrderMessage();
        orderMessage.setRequestId(orderMessage.getSequance());
        if (orderGroups) {
            for (let i = 0, len = orderGroups.length; i < len; i++) {
                orderMessage.FieldSet.AddGroup(orderGroups[i]);
            }
        }
        orderMessage.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);
        this.SendMessage(orderMessage);
    }
    placeOrderGroupsAsync(orderGroups, placedFrom, isMultiply) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const orderMessage = new vendorMessage.NewOrderMessage();
            const reqId = orderMessage.getSequance();
            orderMessage.setRequestId(reqId);
            orderMessage.setPlacedFrom(placedFrom !== null && placedFrom !== void 0 ? placedFrom : PlacedFrom.WEB_OTHER);
            const waiters = [];
            if (orderGroups) {
                for (let i = 0, len = orderGroups.length; i < len; i++) {
                    orderMessage.FieldSet.AddGroup(orderGroups[i]);
                    const pr = new Promise((resolve) => {
                        this.WrappersHandlersTrading[orderGroups[i].getClientOrderId()] = resolve;
                    });
                    waiters.push(pr);
                }
            }
            const rejectCase = new Promise((resolve) => {
                this.WrappersHandlers[reqId] = resolve;
            });
            this.SendMessage(orderMessage);
            const res = yield Promise.race([Promise.all(waiters), rejectCase]);
            if (isMultiply) {
                return res;
            }
            const response = (_a = res[0]) !== null && _a !== void 0 ? _a : res;
            return response;
        });
    }
    // TODO. Ugly. Details are in OCOOrderEdit
    // TODO. Doesn't support StopLimit orders.
    // TODO. Code duplication.
    createOCOGroups(data) {
        const ordTypes = OrderType;
        // TODO. Ewww. UGLY.
        const ocoCustomData = data.ocoCustomOrdersData;
        const firstOrderSide = ocoCustomData ? ocoCustomData.firstOrderSide : data.side;
        const secondOrderSide = ocoCustomData ? ocoCustomData.secondOrderSide : data.side;
        const firstOrderTif = ocoCustomData ? ocoCustomData.firstOrderTif : data.tif;
        const secondOrderTif = ocoCustomData ? ocoCustomData.secondOrderTif : data.tif;
        const firstOrderType = ocoCustomData ? ocoCustomData.firstOrderType : ordTypes.Limit;
        const secondOrderType = ocoCustomData
            ? ocoCustomData.secondOrderType
            : data.useStopLimitInsteadStop
                ? ordTypes.StopLimit
                : ordTypes.Stop;
        // TODO. Doesn't support StopLimit.
        const firstOrderPrice = data.parameterDict.limitPrice;
        const secondOrderPrice = data.parameterDict.stopPrice;
        // First order ugly data mod.
        data.side = firstOrderSide;
        data.tif = firstOrderTif;
        // TODO. UGLY.
        data.parameterDict.limitPrice = (ocoCustomData === null || ocoCustomData === void 0 ? void 0 : ocoCustomData.firstOrderLimitPriceForStopLimit)
            ? ocoCustomData.firstOrderLimitPriceForStopLimit
            : firstOrderPrice;
        data.parameterDict.stopPrice = firstOrderPrice;
        const firstOrderGroup = this.createOrderGroup(data, data.placedFrom);
        if (!firstOrderGroup) {
            return null;
        }
        firstOrderGroup.setOrderType(firstOrderType);
        this.setOrderGroupPrices(data, firstOrderType, firstOrderGroup);
        // Second order ugly data mod.
        data.side = secondOrderSide;
        data.tif = secondOrderTif;
        // TODO. UGLY.
        data.parameterDict.limitPrice =
            data.limitPriceForStopLimitOrder && secondOrderType === ordTypes.StopLimit
                ? data.limitPriceForStopLimitOrder
                : secondOrderPrice;
        if (ocoCustomData === null || ocoCustomData === void 0 ? void 0 : ocoCustomData.secondOrderLimitPriceForStopLimit) {
            data.parameterDict.limitPrice = ocoCustomData.secondOrderLimitPriceForStopLimit;
        }
        data.parameterDict.stopPrice = secondOrderPrice;
        const secondOrderGroup = this.createOrderGroup(data, data.placedFrom);
        if (!secondOrderGroup) {
            return null;
        }
        secondOrderGroup.setOrderType(secondOrderType);
        this.setOrderGroupPrices(data, secondOrderType, secondOrderGroup);
        secondOrderGroup.setOrderIdToLink(firstOrderGroup.getClientOrderId());
        secondOrderGroup.setOrderLinkType(OrderLinkType.ORDER_LINK_CANCEL);
        firstOrderGroup.setOrderIdToLink(secondOrderGroup.getClientOrderId());
        firstOrderGroup.setOrderLinkType(OrderLinkType.ORDER_LINK_CANCEL);
        return [firstOrderGroup, secondOrderGroup];
    }
    // TODO. Rename. Refactor.
    createOrderGroup(data, placedFrom) {
        var _a;
        if (PriceLimitValidation.SendRejectIfNotValidateLimits(data)) {
            // #111427
            return null;
        }
        const acc = data.account;
        const ins = data.instrument;
        const group = new vendorGroup.OrderGroup();
        // TODO. Instead of object.GetHashCode()
        group.setClientOrderId(MathUtils.Round(Math.random() * 1000000, 0).toString());
        group.setOrderType(data.orderTypeId);
        group.setAccountId(parseInt(acc.AcctNumber));
        group.setProductType(parseInt(data.productType));
        group.setInstrumentTradableID(ins.InstrumentTradableID);
        group.setRouteId(ins.getRoute());
        group.setOperationType(data.side);
        if (data.isCashMode) {
            group.setCashOrderQty(data.cash);
        }
        else if (data.quantity) {
            const quantityInLots = Quantity.toLots(data.quantity, ins);
            group.setAmount(quantityInLots);
            const disclosedQty = ((_a = data.disclosedQuantity) === null || _a === void 0 ? void 0 : _a.value) != null
                ? Quantity.toLots(data.disclosedQuantity, ins)
                : data.disclosedQuantity || quantityInLots; // #105398
            group.setDisclosedQty(disclosedQty);
        }
        const tif = data.tif;
        group.setValidity(tif.type);
        if (tif.type === OrderTif.GTD) {
            group.setTIFExpireDate(tif.expirationTime);
        }
        if (data.leverageValue) {
            group.setLeverage(parseInt(data.leverageValue));
        }
        const orderParamDict = data.parameterDict;
        const iSlTpEditParams = orderParamDict.sltp;
        const sltpHolder = iSlTpEditParams === null || iSlTpEditParams === void 0 ? void 0 : iSlTpEditParams.sltpHolder;
        if (!isNullOrUndefined(sltpHolder)) {
            if (!isNaN(sltpHolder.StopLossPriceValue)) {
                group.setSLPriceType(sltpHolder.StopLossPriceType);
                group.setSLPrice(sltpHolder.StopLossPriceValue);
                if (sltpHolder.RealTrStopPrice && !orderParamDict.RealTrStopPrice) {
                    group.setPrice(sltpHolder.RealTrStopPrice);
                }
                if (sltpHolder.SLTPTriggerShortValue !== null) {
                    group.setSLTriggerPrice(SLTPTrigger.GetRawValue(sltpHolder.SLTPTriggerShortValue, data.side, true));
                }
            }
            if (sltpHolder.StopLossLimitPriceValue != null) {
                group.setSLLimitPrice(sltpHolder.StopLossLimitPriceValue);
            }
            if (!isNaN(sltpHolder.TakeProfitPriceValue)) {
                group.setTPPriceType(sltpHolder.TakeProfitPriceType);
                group.setTPPrice(sltpHolder.TakeProfitPriceValue);
                if (sltpHolder.SLTPTriggerShortValue !== null) {
                    group.setTPTriggerPrice(SLTPTrigger.GetRawValue(sltpHolder.SLTPTriggerShortValue, data.side, false));
                }
            }
        }
        group.setOpen(true);
        group.setByBroker(false);
        group.setIsByStrategy(false);
        group.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);
        if (orderParamDict.RealTrStopPrice) {
            group.setPrice(orderParamDict.RealTrStopPrice);
        }
        if (data.comment) {
            group.setComment(data.comment);
        }
        if (isValidString(data.userComment)) {
            group.setUserComment(data.userComment);
        }
        if (!isNullOrUndefined(data.isAllowOTHTrading)) {
            group.isAllowOTHTrading = data.isAllowOTHTrading;
        }
        return group;
    }
    replaceOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const msg = this.createReplaceOrderMessage(data);
            if (!msg)
                return;
            return yield new Promise((resolve, _reject) => {
                const rqi = msg.getSequance();
                msg.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.WrappersHandlersTrading[msg.getOrderId().toString()] = resolve;
                this.SendMessage(msg);
            }).then((msg) => {
                const m = msg[0] || msg;
                this.Notify(m);
                return m.Code !== Message.CODE_BUSINESS_REJECT_MESSAGE;
            });
        });
    }
    // TODO. Ugly. Refactor. Promise?
    createReplaceOrderMessage(data) {
        if (PriceLimitValidation.SendRejectIfNotValidateLimits(data)) {
            // #111427
            return null;
        }
        const acc = data.account;
        const ins = data.instrument;
        const order = data.order;
        const orderType = data.orderTypeId;
        const orderParamDict = data.parameterDict;
        const msg = new vendorMessage.OrderReplaceMessage();
        msg.setOrderId(BigInt(order.OrderNumber));
        msg.setOrderType(orderType);
        msg.setOperationType(data.side);
        msg.setAccountId(parseInt(acc.AcctNumber));
        msg.setInstrumentTradableID(ins.InstrumentTradableID);
        msg.setRouteId(ins.getRoute());
        msg.setPlacedFrom(data.placedFrom || PlacedFrom.WEB_OTHER);
        if (data.quantity) {
            msg.setAmount(Quantity.toLots(data.quantity, ins));
        }
        if (data.disclosedQuantity) {
            msg.setDisclosedQty(Quantity.toLots(data.disclosedQuantity, ins));
        }
        const tif = data.tif;
        msg.setValidity(tif.type);
        if (tif.type === OrderTif.GTD) {
            msg.setTIFExpireDate(tif.expirationTime);
        }
        const orderTypes = OrderType;
        // Setting up prices.
        switch (orderType) {
            case orderTypes.TrailingStop:
                msg.setFieldValue(FieldsFactory.FIELD_TR_OFFSET, orderParamDict.trailingStop);
                if (orderParamDict.RealTrStopPrice) {
                    msg.setPrice(orderParamDict.RealTrStopPrice);
                }
                break;
            case orderTypes.Stop:
                msg.setPrice(orderParamDict.stopPrice);
                break;
            case orderTypes.StopLimit:
                msg.setPrice(orderParamDict.limitPrice);
                msg.setStopPrice(orderParamDict.stopPrice);
                break;
            case orderTypes.Limit:
            case orderTypes.Care:
                msg.setPrice(orderParamDict.limitPrice);
                break;
        }
        // Setting up sl/tp.
        const iSlTpEditParams = orderParamDict.sltp;
        const slTpHolder = iSlTpEditParams === null || iSlTpEditParams === void 0 ? void 0 : iSlTpEditParams.sltpHolder;
        if (!isNullOrUndefined(slTpHolder)) {
            msg.setFieldValue(FieldsFactory.FIELD_SL_PRICE_TYPE, slTpHolder.StopLossPriceType);
            msg.setFieldValue(FieldsFactory.FIELD_SL_PRICE, slTpHolder.StopLossPriceValue);
            msg.setFieldValue(FieldsFactory.FIELD_TP_PRICE_TYPE, slTpHolder.TakeProfitPriceType);
            msg.setFieldValue(FieldsFactory.FIELD_TP_PRICE, slTpHolder.TakeProfitPriceValue);
            if (slTpHolder.StopLossLimitPriceValue != null && !isNaN(slTpHolder.StopLossPriceValue)) {
                msg.setSLLimitPrice(slTpHolder.StopLossLimitPriceValue === null ? NaN : slTpHolder.StopLossLimitPriceValue);
            } // шлём на сервер NaN вместо null
            if (slTpHolder.SLTPTriggerShortValue) {
                if (!isNaN(slTpHolder.StopLossPriceValue) || slTpHolder.StopLossLimitPriceValue != null) {
                    msg.setSLTriggerPrice(SLTPTrigger.GetRawValue(slTpHolder.SLTPTriggerShortValue, data.side, true));
                }
                if (!isNaN(slTpHolder.TakeProfitPriceValue)) {
                    msg.setTPTriggerPrice(SLTPTrigger.GetRawValue(slTpHolder.SLTPTriggerShortValue, data.side, false));
                }
            }
        }
        if (isValidString(data.userComment)) {
            msg.setUserComment(data.userComment);
        }
        let boundToVal = 'boundTo' in orderParamDict ? orderParamDict.boundTo : -1;
        if (boundToVal === NO_BIND_TO) {
            boundToVal = -1;
        }
        msg.setBoundTo(boundToVal);
        // TODO.
        const group = new vendorGroup.OrderGroup();
        group.setByBroker(false);
        msg.FieldSet.AddGroup(group);
        return msg;
    }
    // TODO. Rename. Refactor.
    setOrderGroupPrices(data, orderType, group) {
        const orderParamDict = data.parameterDict;
        const ordTypes = OrderType;
        switch (orderType) {
            case ordTypes.Stop:
                group.setPrice(orderParamDict.stopPrice);
                group.setStopPrice(0);
                break;
            case ordTypes.StopLimit:
                group.setPrice(orderParamDict.limitPrice);
                group.setStopPrice(orderParamDict.stopPrice);
                break;
            case ordTypes.Limit:
            case ordTypes.Care:
                group.setPrice(orderParamDict.limitPrice);
                group.setStopPrice(0);
                break;
            case ordTypes.TrailingStop:
                // let linkPrice = 0
                // if (quote)
                //     linkPrice = buy
                //         ? quote.AskSpread_SP_Ins(DataCache.GetSpreadPlan(), ins)
                //         : quote.BidSpread_SP_Ins(DataCache.GetSpreadPlan(), ins)
                if (orderParamDict.RealTrStopPrice) {
                    group.setPrice(orderParamDict.RealTrStopPrice);
                }
                // group.setPrice(linkPrice || 0)
                group.setTrailingOffset(orderParamDict.trailingStop);
                break;
        }
        const trigger = orderParamDict[OrderEditBaseUtils.SLTP_TRIGGER];
        if (trigger) {
            group.setSLTPTriggerPrice(trigger);
        }
    }
    // TODO. Answer. Promise.
    cancelOrder(order, placedFrom) {
        if (!order)
            return;
        const message = new vendorMessage.CancelOrderMessage();
        message.setOrderId(BigInt(order.OrderNumber));
        message.setAccountId(order.Account.BstrAccount);
        message.setInstrumentTradableID(order.Instrument.InstrumentTradableID);
        message.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);
        // let fromName = GetCorrectFromName(ord.Account, fromName)
        // let isBrokerRequest = IsBrokerRequest(ord.Account, fromName);
        const isBrokerRequest = false;
        message.setIsBrokerRequest(isBrokerRequest);
        message.setRequestId(message.getSequance());
        this.SendMessage(message);
    }
    // TODO. Answer. Promise.
    closePositions(closePositionData, placedFrom) {
        const msg = new vendorMessage.NewOrderMessage();
        for (const closePosition of closePositionData) {
            this.addOrderGroupToClosePosition(msg, closePosition.position, closePosition.quantityToClose, closePosition.isAllowOTHTrading, closePosition.tif, placedFrom, closePosition.mutualPositionIDs);
        }
        msg.setRequestId(msg.getSequance());
        this.SendMessage(msg);
    }
    addOrderGroupToClosePosition(msg, pos, quantityToClose, isAllowOTHTrading, tifObj, placedFrom, mutualPositionsIds) {
        const acc = pos.Account;
        const ins = pos.Instrument;
        const quote = ins.LastQuote;
        if (mutualPositionsIds && mutualPositionsIds[0] != pos.PositionId) {
            return;
        }
        const group = new vendorGroup.OrderGroup();
        msg.addGroup(group);
        // TODO. Instead of object.GetHashCode()
        group.setClientOrderId(MathUtils.Round(Math.random() * 1000000, 0).toString());
        group.setInstrumentTradableID(ins.InstrumentTradableID);
        group.setAccountId(parseInt(acc.BstrAccount));
        group.setOperationType(pos.BuySell);
        group.setProductType(pos.ProductType);
        // group.setLeverage(pos.leverageValue)
        group.setBoundTo(-1);
        group.setValidity(tifObj.type);
        if (tifObj.type === OrderTif.GTD) {
            group.setTIFExpireDate(tifObj.expirationTime);
        }
        let price = 0;
        if (quote) {
            const sp = pos.DataCache.GetSpreadPlan(acc);
            price =
                pos.BuySell === OperationType.Buy ? quote.BidSpread_SP_Ins(sp, ins) : quote.AskSpread_SP_Ins(sp, ins);
            if (isNaN(price)) {
                price = 0;
            }
        }
        group.setPrice(price);
        group.setStopPrice(0);
        const lotsToClose = quantityToClose ? Quantity.toLots(quantityToClose, ins) : pos.Amount;
        group.setAmount(lotsToClose);
        group.setOrderType(OrderType.Market);
        group.isAllowOTHTrading = isAllowOTHTrading;
        // TODO.
        group.setByBroker(false);
        group.setOpen(false);
        group.setIsByStrategy(false);
        group.setRouteId(-1);
        group.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);
        const posList = mutualPositionsIds || [pos.OrderNumber];
        for (let i = 0, len = posList.length; i < len; i++) {
            const posId = BigInt(posList[i]);
            const orderIdGroup = new vendorGroup.OrderIdGroup();
            orderIdGroup.setOrderId(posId);
            group.AddGroup(orderIdGroup);
        }
    }
    // TODO. Answer. Promise.
    // TODO. Refactor. Move to modifyOrder()?
    changeOrderToMarket(order, placedFrom) {
        var _a;
        const msg = new vendorMessage.OrderReplaceMessage();
        msg.setOrderType(OrderType.Market);
        msg.setOrderId(BigInt(order.OrderNumber));
        const price = (_a = order.CurPriceOpen) !== null && _a !== void 0 ? _a : order.CurPriceClose;
        if (isValidNumber(price)) {
            msg.setPrice(price); /* #131391 */
        }
        msg.setRequestId(msg.getSequance());
        msg.setPlacedFrom(placedFrom || PlacedFrom.WEB_OTHER);
        this.SendMessage(msg);
    }
    modifyPositionProductType(positionId, productType, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            const msg = new vendorMessage.ModifyPositionMessage();
            msg.setPositionId(BigInt(positionId));
            msg.setProductType(parseInt(productType));
            const rqi = msg.getSequance();
            msg.setRequestId(rqi);
            msg.setQuantity(quantity);
            yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(msg);
            }).then((msg) => {
                msg = msg[0];
                if (!msg) {
                    return;
                }
                if (msg.IsDirect && msg.Code === Message.CODE_BUSINESS_REJECT_MESSAGE) {
                    msg.Name = 'Product type modification rejected';
                }
                this.Notify(msg);
            });
        });
    }
    sendTradePassword(pass, ExternalResourse) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.PfixOneTimePasswordMessage();
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            })
                .then((msg) => {
                msg = msg[0];
                const message = new vendorMessage.TradingUnlockMessage();
                if (ExternalResourse) {
                    message.setExternalResourse(ExternalResourse);
                }
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                let pr = null;
                const EncrType = msg.EncryptionType();
                if (EncrType !== EncrTypes.AES_GCM_NoPadding) {
                    pr = ProXOREncryptionUtility.Encode(pass, msg.GetPassword()).then((encrPass) => {
                        message.SetPassword(encrPass);
                        return true;
                    });
                }
                else {
                    pr = EncodeKeyAesGcmNoPadding(pass, msg.GetPassword()).then((encrPass) => {
                        message.SetPassword(encrPass);
                        return true;
                    });
                }
                return pr.then(() => __awaiter(this, void 0, void 0, function* () {
                    return yield new Promise((resolve, _reject) => {
                        this.WrappersHandlers[rqi] = resolve;
                        this.SendMessage(message);
                    });
                }));
            })
                .then((msg) => {
                msg = msg[0];
                return msg.getTradingUnlocked();
            });
        });
    }
    SendSOAPRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const soapReqMsg = new vendorMessage.SOAPReqMessage();
                ProcessorWorker.AddProtocolVersonAndMaxField(soapReqMsg);
                soapReqMsg.setName('');
                soapReqMsg.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, FieldsFactory.getInstance().MaxFieldNumber);
                if (request === null) {
                    return 'Bad Arguments';
                }
                const keys = Object.keys(request);
                if (keys.length === 0) {
                    return 'Bad Arguments';
                }
                for (let i = 0; i < keys.length; i++) {
                    const parName = keys[i];
                    const parValue = request[parName];
                    const group = new vendorGroup.KeyValueAggregateGroup();
                    group.setKey(parName);
                    group.setValue(parValue);
                    soapReqMsg.FieldSet.AddGroup(group);
                }
                const rqi = soapReqMsg.getSequance();
                soapReqMsg.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(soapReqMsg);
            }).then(function (msg) {
                msg = msg[0];
                const gr = msg.FieldSet.GetGroups(FieldsFactory.LINE_GROUP_NAME);
                if (!gr.length) {
                    return 'Bad Arguments';
                }
                return gr[0].GetValue(FieldsFactory.FIELD_TEXT);
            });
        });
    }
    SendVerifySessionMsg(sessId) {
        const msg = new vendorMessage.TokenVerifyRequestMessage();
        msg.SetUserSessionId(sessId);
        ProcessorWorker.AddProtocolVersonAndMaxField(msg);
        this.SendMessage(msg);
    }
    ProcessVerifySessionMsg(msg) {
        const answer = { IsExpired: true, Login: null, Opened: true };
        // if (msg.Code === Message.CODE_BUSINESS_REJECT_MESSAGE)
        if (msg.Code === Message.CODE_PFIX_TOKEN_VERIFY_RESPONSE) {
            answer.IsExpired = msg.IsExpired;
            answer.Login = msg.Login;
        }
        return answer;
    }
    static SendTokenVerifyMessage(url, isSSL, sessId, sert) {
        return __awaiter(this, void 0, void 0, function* () {
            const myStream = ProcessorWorker.CreateMyObj(url, isSSL);
            return yield myStream.OpenWS(sert).then(function (opened) {
                if (!opened) {
                    return { IsExpired: true, Login: null, Opened: false };
                }
                myStream.SendVerifySessionMsg(sessId);
                return myStream.MyPrommisseHandler;
            });
            // TODO
            // .CloseStream();
        });
    }
    static GetSessionLessBrandingRules(url, isSSL, brandingKey, sert) {
        return __awaiter(this, void 0, void 0, function* () {
            const myStream = ProcessorWorker.CreateMyObj(url, isSSL);
            return yield myStream.OpenWS(sert).then(function (opened) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!opened) {
                        return { Opened: false };
                    }
                    return yield myStream.GetBrandingRules(brandingKey).then(function (msg) {
                        let data = null;
                        if (msg) {
                            data = msg[0] || msg;
                        }
                        if ((data === null || data === void 0 ? void 0 : data.Code) === Message.CODE_BUSINESS_REJECT_MESSAGE) {
                            data = null;
                        }
                        return { Opened: true, Data: data };
                    });
                });
            });
            // TODO
            // .CloseStream();
        });
    }
    static CreateMyObj(url, isSSL) {
        const stream = new ProcessorWorker(ProcessorWorker.MODE_AUTHENTICATION_REQUEST);
        stream.siteAddres = url;
        stream.isSSL = isSSL;
        stream.MyPrommisseHandler = new Promise(function (resolve, reject) {
            stream.OnError = reject;
            stream.OnNewMessageDelegate = function (msg) {
                resolve(stream.ProcessVerifySessionMsg(msg));
            };
        }).catch(function (errorResovingFunc) {
            errorResovingFunc(false);
        });
        return stream;
    }
    SendAlertToServer(alertData) {
        const isNew = alertData.AlertId === null;
        let msgToSend = null;
        if (isNew) {
            msgToSend = new vendorMessage.CreateAlertMessage();
        }
        else {
            msgToSend = new vendorMessage.ReplaceAlertMessage();
        }
        if (isNew) {
            // немогут определиться // msgToSend.setUserId(alertData.Account.userPin)
        }
        else {
            msgToSend.setAlertId(alertData.AlertId);
        }
        msgToSend.setAlertAccountId(alertData.Account.ID);
        msgToSend.setTradableInstrumentId(alertData.Instrument.InstrumentTradableID);
        msgToSend.setRouteId(alertData.Instrument.Route);
        msgToSend.setAlertType(alertData.AlertType);
        msgToSend.setAlertCondition(alertData.Condition);
        msgToSend.setAlertValue(alertData.Value);
        msgToSend.setAlertImportance(alertData.Importance);
        msgToSend.setAlertDate(alertData.Expiration);
        msgToSend.setAlertAfterExecute(alertData.AfterExecute);
        msgToSend.setAlertAction(alertData.Action);
        msgToSend.setAlertNotification(alertData.Notification);
        msgToSend.isAllowOTHTrading = alertData.IsAllowOTHTrading;
        msgToSend.setAlertText(alertData.MessageText);
        if (alertData.leverageValue) {
            msgToSend.setAlertLeverage(alertData.leverageValue);
        }
        const data = alertData.OrderPlaceParametrs;
        if (data) {
            let orderGroups = null;
            const ordTypes = OrderType;
            const ordType = data.orderTypeId;
            if (ordType === ordTypes.OCO) {
                orderGroups = this.createOCOGroups(data);
            }
            else {
                const orderGroup = this.createOrderGroup(data, data.placedFrom);
                if (!orderGroup) {
                    return;
                }
                this.setOrderGroupPrices(data, ordType, orderGroup);
                orderGroups = [orderGroup];
            }
            for (let i = 0, len = orderGroups.length; i < len; i++) {
                msgToSend.FieldSet.AddGroup(orderGroups[i]);
            }
        }
        msgToSend.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL, PlacedFrom.WEB_ALERT);
        this.SendMessage(msgToSend);
    }
    MakeAlertAction(alertActionInfo) {
        const msg = new vendorMessage.ControlAlertCommandMessage();
        msg.setAlertId(alertActionInfo.AlertId);
        msg.setAlertCommand(alertActionInfo.Command);
        this.SendMessage(msg);
    }
    SendProductSubscriptionRequest(Data) {
        return __awaiter(this, void 0, void 0, function* () {
            const pfixSubscribeRequestMsg = new vendorMessage.PFixEntitlementSubscriptionRequestMessage();
            pfixSubscribeRequestMsg.setProductId(Data.ProductId);
            pfixSubscribeRequestMsg.setRequestType(Data.RequestType);
            for (let i = 0; i < Data.EntitlmentDocuments.length; i++) {
                const doc = Data.EntitlmentDocuments[i];
                const docGroup = vendorGroup.EntitlementDocumentGroup.CreateDocument(doc.Id, doc.Name, doc.Content);
                pfixSubscribeRequestMsg.AddDocument(docGroup);
            }
            const rqi = pfixSubscribeRequestMsg.getSequance();
            pfixSubscribeRequestMsg.setRequestId(rqi);
            yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(pfixSubscribeRequestMsg);
            }).then((newMsg) => {
                if (newMsg) {
                    for (let i = 0; i < newMsg.length; i++) {
                        const msg = newMsg[i];
                        if (msg.Code === Message.CODE_BUSINESS_REJECT_MESSAGE) {
                            msg.ReqProductId = Data.ProductId;
                        }
                        this.Notify(msg);
                    }
                }
            });
        });
    }
    SendProductDocumentRequest(ProductId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pfixGetDocRequestMsg = new vendorMessage.PFixEntitlementProductDocumentRequestMessage();
            pfixGetDocRequestMsg.setProductId(ProductId);
            const rqi = pfixGetDocRequestMsg.getSequance();
            pfixGetDocRequestMsg.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(pfixGetDocRequestMsg);
            });
        });
    }
    SendSubscriptionHistoryReques(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const pfixSubscriptionHistory = new vendorMessage.PfixEntitlementSubscriptionHistoryRequestMessage();
            pfixSubscriptionHistory.setFromUtc(from);
            pfixSubscriptionHistory.setToUtc(to);
            const rqi = pfixSubscriptionHistory.getSequance();
            pfixSubscriptionHistory.setRequestId(rqi);
            const resArray = [];
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(pfixSubscriptionHistory);
            }).then((msg) => __awaiter(this, void 0, void 0, function* () {
                return yield this.SendSubscriptionHistoryResponseCollect(msg, rqi, resArray);
            }));
        });
    }
    SendSubscriptionHistoryResponseCollect(msg, rqi, resArray) {
        return __awaiter(this, void 0, void 0, function* () {
            const m = msg[0];
            resArray.push(m);
            if (m.ResponseEnd) {
                return yield Promise.resolve(resArray);
            }
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
            }).then((newMsg) => __awaiter(this, void 0, void 0, function* () {
                return yield this.SendSubscriptionHistoryResponseCollect(newMsg, rqi, resArray);
            }));
        });
    }
    static AddProtocolVersonAndMaxField(msg) {
        if (!(msg === null || msg === void 0 ? void 0 : msg.setFieldValue)) {
            return;
        }
        const protocolVerson = '1.13';
        msg.setFieldValue(FieldsFactory.FIELD_PROTOCOL_ID, protocolVerson);
        msg.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, FieldsFactory.getInstance().MaxFieldNumber);
        const clientType = ClientType.getClientType();
        msg.setFieldValue(FieldsFactory.FIELD_CLIENT_TYPE, clientType);
    }
    // #endregion Trading
    SendPasswordRecoveryChangeRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const recoveryReq = new vendorMessage.PasswordRecoveryChangeRequest();
            if (data.newPassword) {
                recoveryReq.setPassword(data.newPassword);
            }
            if (data.login) {
                recoveryReq.setLogin(data.login);
            }
            if (data.accessToken) {
                recoveryReq.setAccessToken(data.accessToken);
            } // #92068
            recoveryReq.setKey(data.key);
            ProcessorWorker.AddProtocolVersonAndMaxField(recoveryReq);
            const rqi = recoveryReq.getSequance();
            recoveryReq.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(recoveryReq);
            }).then((msg) => __awaiter(this, void 0, void 0, function* () { return this.processRecoveryResponse(msg); }));
        });
    }
    SendRequestRecoveryPassword(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const recoveryReq = new vendorMessage.RequestRecoveryPassword();
            if (data.login) {
                recoveryReq.setLogin(data.login);
            }
            if (data.email) {
                recoveryReq.setEmail(data.email);
            }
            ProcessorWorker.AddProtocolVersonAndMaxField(recoveryReq);
            const rqi = recoveryReq.getSequance();
            recoveryReq.setRequestId(rqi);
            return yield new Promise((resolve, _reject) => {
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(recoveryReq);
            }).then((msg) => __awaiter(this, void 0, void 0, function* () { return this.processRecoveryResponse(msg); }));
        });
    }
    SendCloseAccountRequestMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, _reject) => {
                const message = new vendorMessage.CloseAccountRequestMessage();
                const rqi = message.getSequance();
                message.setRequestId(rqi);
                this.WrappersHandlers[rqi] = resolve;
                this.SendMessage(message);
            }).then((msgArr) => {
                const msg = msgArr[0] || msgArr;
                this.Notify(msg);
                return msgArr;
            });
        });
    }
    SendCloseAccountCancelRequestMessage(closeAccountRequestID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((_resolve, _reject) => {
                const message = new vendorMessage.CloseAccountCancelRequestMessage();
                message.setCloseAccountRequestID(closeAccountRequestID);
                this.SendMessage(message);
            });
        });
    }
    SendQuotesRequest(tadableIdRouteIdArray) {
        void new Promise((_resolve, _reject) => {
            const message = new vendorMessage.QuotesRequestMessage();
            for (let i = 0; i < tadableIdRouteIdArray.length; i++) {
                message.addQuotesRequestGroup(tadableIdRouteIdArray[i].tradableId, tadableIdRouteIdArray[i].routeId);
            }
            this.SendMessage(message);
        });
    }
    processRecoveryResponse(msg) {
        msg = msg[0];
        if (msg.IsDirect) {
            return {
                status: ChangePasswordStatusEnum.STATUS_DECLINED,
                BusinessRejectCode: msg.BusinessRejectCode,
                errText: msg.Data[0][1]
            };
        }
        return {
            status: msg.getStatus(),
            MinLength: msg.getMinLength(),
            MaxLength: msg.getFieldValue(FieldsFactory.FIELD_MAX_PASSWORD_LENGTH) || 128
        };
    }
}
// #region Constants
// public static readonly CONNECTED = 0;
// public static readonly RECONNECTING = 1;
// public static readonly DISCONNECTED = 2;
// public static readonly SOKET_MESSAGE_MODE_INFO = 0;
// public static readonly SOKET_MESSAGE_MODE_UPLOAD = 2;
// public static readonly SOKET_MESSAGE_MODE_DELETE = 3;
ProcessorWorker.SOKET_MESSAGE_MODE_NEW_FORMAT = 4;
ProcessorWorker.MAX_BARS_TO_READ = 400000;
/// <summary>
/// Режим работы вендора - только котировки
/// </summary>
ProcessorWorker.MODE_AUTHENTICATION_REQUEST = 0x00;
/// <summary>
/// Режим работы вендора - только котировки
/// </summary>
ProcessorWorker.MODE_QUOTESTREAM = 0x01;
/// <summary>
/// Режим работы вендора - торговля
/// </summary>
ProcessorWorker.MODE_TRADESTREAM = 0x02;
/// <summary>
/// Режим работы вендора - история
/// </summary>
ProcessorWorker.MODE_HISTORYSTREAM = 0x04;
/// <summary>
/// Режим работы вендора - новости
/// </summary>
ProcessorWorker.MODE_NEWSTREAM = 0x08;
/// <summary>
/// Редим работы вендора - один сервер на все
/// </summary>
ProcessorWorker.MODE_SINGLE_SERVER = ProcessorWorker.MODE_QUOTESTREAM | ProcessorWorker.MODE_TRADESTREAM | ProcessorWorker.MODE_HISTORYSTREAM;
